import randomstring from "randomstring"

export function generateRandomString(stringLength){
	return randomstring.generate(stringLength);
}